// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__Wh1OY","container":"Footer_container__Fp5tK","segment":"Footer_segment__7EIeL"};